import { css } from "lit";

export const styles = css`
  .collaborators-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--sds-size-space-400) 0 0;
    gap: var(--sds-size-space-300);
  }
`;
